import React, { Component } from 'react'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { AppState, Dispatch } from 'store/types'
import { logout } from 'ducks/auth/operations'
import Link from 'components/UI/Link'
import { DownCaratIcon } from 'components/icons'
import DropMenu from 'components/UI/DropMenu'
import DropdownList from 'components/common/DropdownList'
import { routePath } from 'routes'
import { AccountOptions } from './AccountOptions'
import { AdminOptions } from './AdminOptions'
import styled from 'styled-components'
import {
  AccountMenu,
  HeaderContent,
  Logo,
  NavBar,
  ButtonsBlock,
  HeadLink,
  HeaderButtons
} from './styles'
import { fetchConfigurationLogoHeader } from '../../../ducks/references/operations'

interface HeaderState {
  logo: any
}
class Header extends Component<Props, HeaderState> {
  constructor(props: Props) {
    super(props)

    this.state = {
      logo: ''
    }
  }
  getPatientsButton(text: string) {
    return <HeadLink>{text}</HeadLink>
  }
  componentDidMount(): void {
    this.props.fetchConfigurationLogoHeader()
  }
  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (prevProps.logo !== this.props.logo) {
      console.log("Logos", this.props.logo)
      this.setState({ logo: this.props.logo.contentHeader })
    }
  }

  render() {
    const menuOptions = AccountOptions(this.props)
    const adminMenuOptions = AdminOptions(this.props);
    const { isAuthenticated, isAdmin, isCms } = this.props

    return (
      <NavBar>
        <Container>
          <Row>
            <Col col={true}>
              <HeaderContent>
                <Link to={routePath.INDEX}>
                  {/* <Image src={this.state.logo} /> */}
                  {this.state.logo && (
                    <img
                      style={{ backgroundSize: "cover", objectFit: "contain",  maxWidth: "200px", maxHeight: "150px" }}
                      width={'auto'}
                      height={'auto'}
                      src={this.state.logo}
                    />
                  )}
                </Link>
                <ButtonsBlock>
                  <HeaderButtons>
                    {isAuthenticated && (
                      <Link
                        to={routePath.ESTIMATES_PAGE}
                        custom={this.getPatientsButton('Estimates')}
                      />
                    )}
                    {isCms && (
                      <Link
                        to={routePath.CMS_REPORT}
                        custom={this.getPatientsButton('CMS Price Transparency Report')}
                      />
                    )}
                    {isAdmin && (
                      <Link
                        to={routePath.PATIENTS_LIST}
                        custom={this.getPatientsButton('Users')}
                      />
                    )}
                  </HeaderButtons>
                    {isAdmin && (
                    <AdminBlock>
                        <DropMenu
                        target={
                            <AccountMenu>
                            <span>Admin</span> <DownCaratIcon />
                            </AccountMenu>
                        }
                        >
                            <DropdownList menuOptions={adminMenuOptions} />
                        </DropMenu>
                    </AdminBlock>
                    )}
                  {isAuthenticated && (
                    <div>
                      <DropMenu
                        target={
                          <AccountMenu>
                            <span>Account</span> <DownCaratIcon />
                          </AccountMenu>
                        }
                      >
                        <DropdownList menuOptions={menuOptions} />
                      </DropMenu>
                    </div>
                  )}
                </ButtonsBlock>
              </HeaderContent>
            </Col>
          </Row>
        </Container>
      </NavBar>
    )
  }
}

// tslint:disable-next-line:no-empty-interface
interface ReceivedProps { }

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
export type Props = StateProps & DispatchProps & ReceivedProps & HeaderState

const mapStateToProps = (state: AppState) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isAdmin: state.auth.isAdmin,
  isCms: false,
  logo: state.references.configurationLogo,
  configurationLogo: state.references.configurationLogo.contentHeader
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ logout, fetchConfigurationLogoHeader }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)


const Image = styled.img`
  max-width: 120px;
  max-height: 90px;
  width: auto;
  height: auto;
  object-fit: contain;
  margin-bottom: 3rem;
`

const AdminBlock = styled.div`
    margin-right: 1.5rem;
`